import HideHeaderButtons from 'src/javascripts/components/tables/checkboxes/HideHeaderButtons';
import ToastCustom from 'src/javascripts/components/alerts/ToastCustom';

// Bulk create using selected record IDs from a table
export default function(tableId) {

  $('.create-bulk').off().on('click', function() {
    let url = $(this).data('url');
    let params = {};
    params['record_ids'] = $('#' + tableId).data('record-ids');
    $.ajax({
      type: 'POST',
      dataType: 'application/json',
      url: url + '?' + $.param(params),
      complete(result) { 

        // Reload table
        $('#' + tableId).DataTable().ajax.reload();

        // Let user know that enabled/created records
        ToastCustom({title: 'Success', message: 'Successfully enabled selected records', delay: 8000, autohide: true, type: 'success'});

        // Hide header buttons
        HideHeaderButtons(tableId);

      }

    });

  })


}

